import React from 'react';

import BookprocessWidgetProps from './interfaces/BookprocessWidgetPropsInterface';

export default class WidgetInput<P extends BookprocessWidgetProps, S = {}> extends React.Component<
    P,
    S
> {
    constructor(props: P) {
        super(props);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getRenderValue = this.getRenderValue.bind(this);
        if (props.value && props.type !== 'radio') {
            this.props.handleChange(props.name, props.value);
        }
    }

    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(this.props.name, event.target.value);
    }

    onBlur(event: React.ChangeEvent<HTMLInputElement>) {
        if (this.props.type === 'number' && event.target.value === '0') {
            event.target.value = '';
        }
    }

    getRenderValue() {
        if (this.props.type === 'radio' && this.props.value) {
            return this.props.value;
        }
        let stateValue = this.props.getStateValue(this.props.name);
        if (stateValue === '') {
            return '';
        }
        return stateValue || this.props.value || '';
    }

    render(): React.DetailedReactHTMLElement<React.HTMLAttributes<HTMLElement>, HTMLElement> {
        return React.createElement('input', {
            id: this.props.id,
            name: this.props.name,
            key: this.props.id,
            type: this.props.type,
            min: this.props.min,
            max: this.props.max,
            required: this.props.required,
            value: this.getRenderValue(),
            disabled: this.props.disabled || this.props.max === 0,
            onChange: this.onChange,
            onBlur: this.onBlur,
            checked:
                this.props.type === 'radio'
                    ? this.props.value == this.props.getStateValue(this.props.name)
                    : undefined,
            placeholder: '​', // Add "zero width space" as placeholder so we can style empty inputs using :placeholder-shown
        });
    }
}
